const GA4_BUSINESS_ID = import.meta.env.VITE_GA4_BUSINESS_ID;
const GA4_GLOBAL_ID = import.meta.env.VITE_GA4_GLOBAL_ID;

export const GA_IDS = [GA4_BUSINESS_ID, GA4_GLOBAL_ID];

const ymId = import.meta.env.VITE_YM_ID;

export const ymIds = [ymId];
